import { TemplateConfig } from '../types';

export const compoundCheckConfig: TemplateConfig = {
  id: 'compound-check',
  name: '是否能复合',
  description: '检查数据是否能够复合处理',
  cardCount: 3,
  
  fieldDefaults: {
    title: '能不能和前任复合',
    customerQuestion: '**我和他还能不能复合，他想不想复合**。请较为明确地回答"能否复合"的问题，不要给出太模棱两可的答案。',
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 1 行第 2 张牌',
      '请输入第 1 行第 3 张牌'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#1890ff',
    backgroundColor: '#f0f8ff',
    icon: '🔗'
  },

  spreadLayout: {
    coordinate: 'normalized',
    cardSize: {
      widthRatio: 0.25,
      heightRatio: 0.65875,
      anchor: 'center'
    },
    positions: [
      { x: 0.2, y: 0.5 },
      { x: 0.5, y: 0.5 },
      { x: 0.8, y: 0.5 }
    ]
  }
};
